/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_duplicate': {
    width: 16,
    height: 16,
    viewBox: '0 0 19.895 20',
    data: '<path pid="0" data-name="Union 7" d="M1.429 20A1.43 1.43 0 010 18.572V7.516a1.431 1.431 0 011.429-1.429h11.056a1.431 1.431 0 011.428 1.429v11.056A1.43 1.43 0 0112.485 20zm13.788-6.087v-6.4a2.736 2.736 0 00-2.732-2.733h-6.5V1.427A1.43 1.43 0 017.414-.002H18.47a1.43 1.43 0 011.428 1.429v11.056a1.43 1.43 0 01-1.428 1.428z" _fill="#3054a0"/>'
  }
})
